import style from './join-us-section.module.scss';
import template from '@components/careers/vacancies/vacancies.module.scss';
import Image from 'next/image';
//carousel
import { Swiper, SwiperSlide } from 'swiper/react';
import { Autoplay } from 'swiper';
// carousel styles
import 'swiper/css';
import 'swiper/css/autoplay';
import { useEffect, useState } from 'react';

interface IJoinUsSection {
  title: string;
  subtitle: string;
  images: string[];
}
// Constant for Carousel Adaptive
const DesktopSlides = 3.2;
const TabletSlides = 2;
const PhoneSlides = 1.2;
const JoinUsSection = ({ title, subtitle, images }: IJoinUsSection) => {
  const [slidesCount, setSlideCount] = useState(DesktopSlides);

  useEffect(() => {
    slidesCounting();
    window.onresize = slidesCounting;

    function slidesCounting() {
      if (document.body.offsetWidth > 1200) {
        setSlideCount(DesktopSlides);
      }
      if (document.body.offsetWidth <= 1200) {
        setSlideCount(TabletSlides);
      }
      if (document.body.offsetWidth <= 768) {
        setSlideCount(PhoneSlides);
      }
    }
  }, []);
  return (
    <section className={`${template.section} ${template.section_gray}`}>
      <div className={`${template.container} ${template.container_small} ${template.mb40}`}>
        <div className={`${template.title} ${template.title_large} ${template.text_align_c} ${template.mb16}`}>
          {title}
        </div>
        <div className={`${template.text} ${template.text_color_main} ${template.text_small} ${template.text_align_c}`}>
          {subtitle}
        </div>
      </div>
      <div className={`${style.container} ${template.mb20}`}>
        <div className={`${style.carousel}`}>
          <Swiper
            modules={[Autoplay]}
            spaceBetween={20}
            slidesPerView={slidesCount}
            autoplay={{
              delay: 5000,
              disableOnInteraction: false,
            }}
            loop={true}
            mousewheel={true}
            speed={1000}
          >
            {images.map((item: string, index: number) => {
              return (
                <SwiperSlide key={index}>
                  <div className={`${style.carousel__item}`}>
                    <Image src={item} alt="carousel-item" layout={'fill'} />
                  </div>
                </SwiperSlide>
              );
            })}
          </Swiper>
        </div>
      </div>
    </section>
  );
};

export default JoinUsSection;
